import React from "react";
import { Link } from "react-router-dom";
import { FiArrowDown, FiArrowRight } from "react-icons/fi";
import Header from "./Header";
import Footer from "./Footer";
import { ProductCard } from "./Shop";
import "../css/main.scss";
import { newArrivals } from "../Datas/productData";
import siteConfig from "../config/siteConfig";

function Main() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="home">
      <Header />
      <main>
        <section className="home-hero" aria-labelledby="home-hero-title">
          <img src="/main/hero.jpg" alt="Two models wearing original indigo denim in a sunlit courtyard" />
          <div className="home-hero__shade" />
          <div className="home-hero__content">
            <span className="eyebrow">Organic denim · Spring / Summer 2026</span>
            <h1 id="home-hero-title">Good jeans<br />get better.</h1>
            <p>Wear them hard. Care for them well. Keep them long enough to become entirely yours.</p>
            <Link className="app-button app-button--light" to="/shop" onClick={toTop}>Shop the collection</Link>
          </div>
          <a className="home-hero__scroll" href="#home-new"><span>Explore</span><FiArrowDown /></a>
        </section>

        <section className="home-manifesto">
          <div className="home-manifesto__copy">
            <span className="eyebrow">Make use, not waste</span>
            <h2>Tomorrow’s vintage begins today.</h2>
            <p>
              We make clothes to collect stories, not dust. Organic fibers, honest construction,
              and care-minded details give every piece a longer first life — and a real second one.
            </p>
            <Link to="/product-care" onClick={toTop}>Our wear and care guide <FiArrowRight /></Link>
          </div>
          <figure className="home-manifesto__image">
            <img src="/main/repair.jpg" alt="Denim maker repairing a well-worn pair of jeans" loading="lazy" />
            <figcaption>Repair first. Replace last.</figcaption>
          </figure>
        </section>

        <section className="home-products" id="home-new">
          <header className="home-products__header">
            <h2>New arrivals</h2>
            <Link to="/shop" onClick={toTop}>View all <FiArrowRight /></Link>
          </header>
          <div className="home-products__rail">
            {newArrivals.slice(0, 8).map((product, index) => (
              <ProductCard key={product.id} product={product} eager={index < 4} />
            ))}
          </div>
        </section>

        <section className="home-editorial">
          <img src="/main/easy.jpg" alt="Relaxed model in light-wash denim beside the sea" loading="lazy" />
          <div className="home-editorial__copy">
            <span className="eyebrow">The easy edit</span>
            <h2>Looser. Lighter.<br />Ready for miles.</h2>
            <Link className="app-button app-button--light" to="/shop?fit=Loose" onClick={toTop}>Go easy</Link>
          </div>
        </section>

        <section className="home-shop-split" aria-label="Shop by collection">
          <Link to="/shop?gender=Men" onClick={toTop}>
            <img src="/img/products/product-02.jpg" alt="Men's loose indigo denim collection" loading="lazy" />
            <span>Shop men <FiArrowRight /></span>
          </Link>
          <Link to="/shop?gender=Women" onClick={toTop}>
            <img src="/img/products/product-09.jpg" alt="Women's high-waist indigo denim collection" loading="lazy" />
            <span>Shop women <FiArrowRight /></span>
          </Link>
        </section>

        <section className="home-journal">
          <header>
            <span className="eyebrow">Field notes</span>
            <h2>From the journal</h2>
          </header>
          <div className="home-journal__grid">
            <Link to="/about" onClick={toTop} className="home-journal__feature">
              <img src="/main/community.jpg" alt="Friends in repaired denim gathered outside a workshop" loading="lazy" />
              <div><span>People</span><h3>A pair of jeans is never really finished</h3><p>Meet the wearers who keep mending, marking, and passing denim on.</p></div>
            </Link>
            <Link to="/about" onClick={toTop} className="home-journal__note home-journal__note--orange">
              <span>Materials</span>
              <h3>Why organic cotton is only the beginning</h3>
              <FiArrowRight />
            </Link>
            <Link to="/about" onClick={toTop} className="home-journal__note home-journal__note--beige">
              <span>Care guide</span>
              <h3>Six quiet ways to make denim last longer</h3>
              <FiArrowRight />
            </Link>
          </div>
        </section>

        <section className="home-closing">
          <p>{siteConfig.tagline}</p>
          <Link to="/shop" onClick={toTop}>Find your next pair <FiArrowRight /></Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Main;
